
  document.addEventListener('DOMContentLoaded', function () {
    var stickyBuyNowButton = document.getElementById('sticky-buy-now');
    var onPageBuyNowButtons = document.getElementsByClassName('product-form__buttons');

    function checkButtonVisibility() {
        if (onPageBuyNowButtons.length > 0) {
            var onPageBuyNowButton = onPageBuyNowButtons[0];
            var rect = onPageBuyNowButton.getBoundingClientRect();
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

            if (!(rect.bottom < 0 || rect.top - viewHeight >= 0)) {
                // On-page button is visible
                stickyBuyNowButton.style.display = 'none';
            } else {
                // On-page button is not visible
                stickyBuyNowButton.style.display = 'flex';
            }
        } 
    }

    window.addEventListener('scroll', checkButtonVisibility);
    window.addEventListener('resize', checkButtonVisibility);
    checkButtonVisibility();

    // Updated click behavior: scroll to very top of page
    if (stickyBuyNowButton) {
        stickyBuyNowButton.addEventListener('click', function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});
